module.exports = __webpack_public_path__ + "static/poster-be1f9a0caf598d5d618da80a2b33de4e.jpg";